import { OverlayRef } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

import { isSupportsPDFs } from '@models';
import { BaseMin } from '@utils/base-min';
import { PublicApiService } from '@services/api.service';
import { StoreService } from '@services/store.service';
import { LoadingComponent } from '@utils/loading.component';

@Component({
    selector: 'vz-pdf-preview',
    template: `
        @if (isEmbedSupported) {
            <button class="ant-btn-icon-only"
                style="position: absolute; top: 0; right: 0; z-index: 3001;"
                nz-button
                nzSize="small"
                (click)="overlayRef!.dispose()">
                <i class="vzi-close"></i>
            </button>
            @if (src) {
                <embed type="application/pdf" [src]="src" class="fit" style="z-index: 2000; width: 100%; height: 100%;" />
            }
        }
        @else {
            <ngx-extended-pdf-viewer
                class="fit"
                style="z-index: 2000"
                [src]="src!"
                [textLayer]="true"
                [showOpenFileButton]="false"
                [showHandToolButton]="true"
                [sidebarVisible]="true" />
            <i class="vz-btn-c-err vzi-close ml1"
                style="position: absolute; top: 7px; right: 7px; z-index: 3001;"
                (click)="overlayRef!.dispose()">
            </i>
        }
        @if (_loading()) {
            <vz-loading [global]="true" text="Загрузка файла..." style="z-index: 3000" />
        }
    `,
    preserveWhitespaces: false,
    imports: [CommonModule, NgxExtendedPdfViewerModule, NzButtonModule, LoadingComponent]
})
export class PdfPreviewComponent extends BaseMin {
    _hostFit = true;
    @HostListener('window:keydown', ['$event'])
    globalTouch(e: KeyboardEvent): void {
        if (e.key == 'Escape' && !e.ctrlKey && !e.shiftKey && !e.altKey && !e.metaKey && this.overlayRef) {
            this.overlayRef.dispose();
        }
    }

    isEmbedSupported = isSupportsPDFs();
    src?: any;
    overlayRef?: OverlayRef;

    private readonly _api       = inject(PublicApiService);
    private readonly _sanitizer = inject(DomSanitizer);

    showPdf(fileId: string, overlayRef: OverlayRef): void {
        this.overlayRef = overlayRef;

        // this._api.getFileDownloadLink(fileId).subscribe({
        //     next: url => {
        //         this.src = this.isEmbedSupported ? this._sanitizer.bypassSecurityTrustResourceUrl(url) : url;
        //         this.loading = false;
        //         this._cdr.markForCheck();
        //     },
        //     error: () => {
        //         this.loading = false;
        //         this._cdr.markForCheck();
        //     }
        // });

        this._Loading(this._api.getFileContent(fileId, 'pdf')).subscribe({
            next: blob => {
                if (this.isEmbedSupported) {
                    this.__U(['src']);
                    const durl = URL.createObjectURL(blob);
                    this._S.src = { unsubscribe: () => URL.revokeObjectURL(durl) };
                    this.src = this._sanitizer.bypassSecurityTrustResourceUrl(durl);
                }
                else {
                    this.src = blob;
                }
            },
        });
    }

}
